import React, { useEffect } from 'react'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import constants from 'constants/index'

const ConsentReportPdf = ({
  consentForms = [],
  receipt = {},
  exportingPdf = false,
  fields = [],
  refresh = () => {},
  reportSelected,
  setExportingPdf = () => {},
  userSelected = '',
}) => {
  const snackbar = useSnackbar()

  const { EXPORT_FORMAT_TYPES } = constants.reports

  useEffect(() => {
    const generateReport = () => {
      try {
        const consentFormIds = consentForms.map((form) => form.id)

        service.dponet.consent.consentFormExportReport({
          receipt,
          consentFormIds,
          reportType: reportSelected,
          fields,
          exportFormat: EXPORT_FORMAT_TYPES.PDF,
          userEmail: userSelected?.userEmail,
        })

        snackbar.open({
          message: 'O relatório será gerado e enviado por e-mail!',
          variant: 'success',
        })
        refresh()
      } catch (error) {
        snackbar.open({
          message: 'Houve um erro durante o processamento de dados.',
          variant: 'error',
        })
      } finally {
        setExportingPdf(false)
      }
    }
    if (exportingPdf) {
      generateReport()
    }
  }, [exportingPdf])
  return <></>
}

export default ConsentReportPdf
